export const versionDefaults = {
    autosaveInterval: 2000
};

//# sourceMappingURL=defaults.js.map